/**
 * @desc 检查平台订单号是否可用
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderCorrelation/checkUsableBySoOrderNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
